/** Connector source kinds shown in the assistant + menu. */
export type AssistantConnectorKind = 'web' | 'langflow_flow' | 'mcp_tool';

export type AssistantConnectorItem = {
  id: string;
  kind: AssistantConnectorKind;
  label: string;
  description?: string;
  /** Langflow flow UUID when kind is langflow_flow. */
  flowId?: string;
  /** MCP tool name when kind is mcp_tool. */
  mcpTool?: string;
};

export type AssistantConnectorSelection = {
  web: boolean;
  flowIds: string[];
  mcpTools: string[];
};

export const DEFAULT_CONNECTOR_SELECTION: AssistantConnectorSelection = {
  web: true,
  flowIds: [],
  mcpTools: [],
};

export function normalizeConnectorSelection(
  raw: Partial<AssistantConnectorSelection> | null | undefined
): AssistantConnectorSelection {
  return {
    web: raw?.web !== false,
    flowIds: Array.isArray(raw?.flowIds) ? raw!.flowIds.filter(Boolean) : [],
    mcpTools: Array.isArray(raw?.mcpTools) ? raw!.mcpTools.filter(Boolean) : [],
  };
}
